import axios from 'axios';
import { supplant } from '@utils/string.utils';

/**
 * 遍历resources映射文件,构造出一个service构造函数
 * @param configs resources映射文件 Array
 * @returns {Clazz}
 */
export default function (configs: Array<any>) {
    const apis: any = {};

    configs.forEach(function (config: any) {
        const { name, url, query, isGraphql, method, cache } = config; //默认为graphql
        /**
         * 动态构造方法
         * @param supplants Object 变量内插对象
         * @param data 调用该方法传入的值
         * @param customConfig 请求配置信息，例如：timeout等
         * @returns {*}
         */
        apis[name] = function (supplants: any, data = {}, customConfig = {}) {
            let params: any = {
                headers: {},
                method: method.toUpperCase(),
                cache,
                url: supplants ? supplant(url, supplants) : url
            };
            const methodKey: 'params' | 'data' = params.method === 'GET' ? 'params' : 'data';

            if (data) {
                params[methodKey] = isGraphql
                    ? {
                          operationName: name,
                          query,
                          variables: data
                      }
                    : data;
            }

            // 从缓存中获取
            if (params.method === 'GET' && cache) {
                const cacheKey = cache.generateKey(params);
                const cacheVal = cache.get(cacheKey);
                if (cacheVal !== null) {
                    return Promise.resolve(cacheVal);
                }
            }

            // 扩展其他自定义字段
            customConfig && (params = Object.assign(params, customConfig));

            //标准化返回结果,使用reject接收error,resolve接收success
            return axios
                .request(params)
                .then((res: any) => {
                    let resData = res.data;
                    const { code, message, status } = res.data || {};
                    if (status && status.toLowerCase() === 'error') {
                        const rj = {
                            code,
                            message,
                            data: res.data
                        };
                        return Promise.reject(rj);
                    }
                    // 设置缓存
                    if (method === 'GET' && cache) {
                        const cacheKey = cache.generateKey(params);
                        cache.set(cacheKey, res.data);
                    }
                    return Promise.resolve(resData);
                })
                .catch((error: any) => {
                    if (axios.isCancel(error)) {
                        return Promise.reject(error);
                    }
                    if (error.response && error.response.data) {
                        return Promise.reject(error.response.data);
                    }
                    return Promise.reject(error);
                });
        };
    });

    return apis;
}
